export default {
  props: ['info'],
  data: () => {
    return {
      tableList: []
    };
  },

  computed: {
    isTrust() {
      if (!this.info.category) return false;
      return this.info.category.indexOf('001') === 0;
    },
    isNongji() {
      if (!this.info.category) return false;
      return this.info.category.indexOf('003') === 0;
    },
    serviceType() {
      if (!this.info.category) return '';

      if (this.info.category.indexOf('002') === 0) {
        return '飞防服务';
      }
      if (this.isNongji) {
        return '农机服务';
      }
      return;
    }
  },

  methods: {
    indexMethod(index) {
      return index+1;
    }
  }
};
